import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers';
import { ReduxLoggerOptions } from '../types/reduxLogger';

declare global {
  interface Window {
    reduxLogger?: {
      createLogger: (options?: ReduxLoggerOptions) => typeof thunk;
    };
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const middleware = [thunk];

if (typeof window !== 'undefined' && window.reduxLogger) {
  middleware.push(
    window.reduxLogger.createLogger({
      diff: true,
      duration: true,
      collapsed: true,
      stateTransformer(state) {
        return state.toJS();
      },
    })
  );
}

// link to redux devtools extension repo: https://github.com/zalmoxisus/redux-devtools-extension
// In order to use this you will need to download the redux devtools chrome extension: https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en-US
const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || // eslint-disable-line no-underscore-dangle
  compose;

const configureStore = (preloadedState = {}) =>
  createStore(
    reducers,
    preloadedState,
    composeEnhancers(applyMiddleware(...middleware))
  );

export default configureStore;
